import { ShippingFlowSelectorOptionsEnum } from '../../constants/addressBook';
import { ICommonAddress } from '../../types/shipping';
import { isObjectEmpty } from '../../utils/helpers';

export const getSelectOptions = (isDelayedShipping: boolean, isFixedDisabled: boolean = false) => [
  ...(isDelayedShipping
    ? [
        {
          value: ShippingFlowSelectorOptionsEnum.RecipientDecides,
          label: 'Recipient decides',
        },
        {
          value: ShippingFlowSelectorOptionsEnum.RecipientDecidesFromList,
          label: 'Recipient decides from list only',
        },
      ]
    : []),
  {
    value: ShippingFlowSelectorOptionsEnum.Fixed,
    label: 'Fixed',
    disabled: isFixedDisabled,
  },
];

// Office dropship is Address Book only: the toggle appears once an entry is actually selected.
export const isOfficeDropshipToggleVisible = ({
  selectValue,
  org_address_ids,
  receiver_address,
}: {
  selectValue: ShippingFlowSelectorOptionsEnum;
  org_address_ids?: (string | undefined)[];
  receiver_address?: ICommonAddress;
}) => {
  const hasSelectedAddressBookIds = !!org_address_ids?.some(Boolean);

  return selectValue === ShippingFlowSelectorOptionsEnum.Fixed
    ? hasSelectedAddressBookIds || !isObjectEmpty(receiver_address)
    : hasSelectedAddressBookIds;
};

// Once the address book selection is gone the toggle is hidden.
export const resolveOfficeDropshipEnabled = ({
  selectValue,
  org_address_ids,
  receiver_address,
  is_office_dropship_enabled,
}: {
  selectValue: ShippingFlowSelectorOptionsEnum;
  org_address_ids?: (string | undefined)[];
  receiver_address?: ICommonAddress;
  is_office_dropship_enabled?: boolean;
}) => {
  if (!is_office_dropship_enabled) {
    return is_office_dropship_enabled;
  }

  return isOfficeDropshipToggleVisible({ selectValue, org_address_ids, receiver_address })
    ? is_office_dropship_enabled
    : false;
};

export const getInitialSelectorState = <T extends object | undefined>({
  is_receiver_address_fixed,
  is_delayed_shipping,
  address,
}: {
  is_receiver_address_fixed: boolean;
  is_delayed_shipping: boolean;
  address: T;
}) => {
  if (!is_delayed_shipping) {
    return ShippingFlowSelectorOptionsEnum.Fixed;
  }

  if (!is_receiver_address_fixed) {
    return ShippingFlowSelectorOptionsEnum.RecipientDecides;
  }

  return typeof address === 'undefined' || isObjectEmpty(address)
    ? ShippingFlowSelectorOptionsEnum.RecipientDecidesFromList
    : ShippingFlowSelectorOptionsEnum.Fixed;
};
